import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { CheckIcon } from "@heroicons/react/24/outline";
import MarkdownWrapper from "@/components/markdownWrapper";
import MediaWrapper from "@/components/mediaWrapper";

export const query = graphql`
  fragment FeaturesWithFeatureListData on StrapiComponentFeaturesWithFeatureList {
    title
    topic
    description
    items {
      title
      description
      icon {
        ...StrapiMediaSubquery
      }
    }
  }
`;

function WithFeatureList({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:px-8 lg:py-24">
        <div>
          {data.topic && (
            <h3 className="text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="mt-2 text-3xl font-extrabold text-text-primary">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-4 text-lg text-text-secondary"
              replaceParagraph={false}
            />
          )}
        </div>
        {Boolean(data.items?.length) && (
          <div className="mt-12 lg:col-span-2 lg:mt-0">
            <dl
              className={`space-y-10 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:space-y-0 lg:gap-x-8 ${
                data.items.find((item) => item.description)
                  ? "sm:gap-y-10"
                  : "sm:gap-y-4"
              }`}
            >
              {data.items.map(
                (item, index) =>
                  index < 20 && (
                    <div key={index} className="relative">
                      <dt>
                        {item.icon ? (
                          <MediaWrapper
                            media={item.icon}
                            objectFit="contain"
                            divClassName="absolute h-6 w-6 text-text-primary"
                            aria-hidden="true"
                          />
                        ) : (
                          <CheckIcon
                            className="absolute h-6 w-6 text-text-primary"
                            aria-hidden="true"
                          />
                        )}
                        {item.title && (
                          <MarkdownWrapper
                            text={item.title}
                            markdownClassName="ml-9 text-lg leading-6 font-medium text-text-primary"
                          />
                        )}
                      </dt>
                      {item.description && (
                        <dd className="ml-9 mt-2 text-base text-text-secondary">
                          <MarkdownWrapper text={item.description} />
                        </dd>
                      )}
                    </div>
                  )
              )}
            </dl>
          </div>
        )}
      </div>
    </div>
  );
}

WithFeatureList.propTypes = {
  data: PropTypes.object,
};

export default WithFeatureList;
